<template>
  <v-dialog v-model="openFilter" persistent max-width="450">
    <v-card>
      <v-card-title>Filters</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="filters.kind" :items="form.leadTypesSelect" label="Lead type" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-menu ref="menu" max-width="400" v-model="menu" :close-on-content-click="false" :return-value.sync="filters.date" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="filters.date" label="Date" readonly dense outlined hide-details v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="filters.date" full-width no-title scrollable :max="allowedDates" @change="$refs.menu.save(filters.date)"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox v-model="filters.voidLead" label="Voided Leads" hide-details class="mt-0"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearForm()">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submitForm(filters)">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from 'moment';

export default {
  data () {
    return {
      menu: false,
      form: {leadTypesSelect: ['Voip', 'Web', 'Telco']},
      filters: {kind: [], date: moment(new Date()).format('YYYY-MM-DD'), voidLead: false, page:1, paginationCount: 0}
    }
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    allowedDates() {
      return moment(new Date()).format('YYYY-MM-DD');
    }
  },

  methods: {
    ...mapActions("daily", ["filterDailyLeads","updateDailyPagination"]),
    closeDialog(){this.$emit('closeDialog');},
    clearForm() {
      this.filters.kind = [];
      this.filters.date = moment(new Date()).format('YYYY-MM-DD');
      this.filters.voidLead = false;
    },
    submitForm(filters) {
      this.updateDailyPagination(this.filters);
      this.$emit('closeDialog', false);
    }
  }
}
</script>

<style>

</style>
